import { ControlledLoginForm } from '@/forms'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_unauthRoutes/login')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ControlledLoginForm />
}
